module.exports = "<div class=\"col-xs-3\">\n\t<left-pane></left-pane>\n</div>\n<div class=\"col-xs-9\">\n\t<div>\n\t\t<nav-bar></nav-bar>\n\t</div>\n\t<div class=\"row\">\n\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/andrews-page/andrews-page.component.html
// module id = ./src/app/andrews-page/andrews-page.component.html
// module chunks = main